import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

import { PropertyDataV2, ResponseData } from "../common"

interface PropertiesFromRecommendedRequestData {
  id: string
  propertyId?: string
}

export interface GetPropertiesFromRecommendedRequest
  extends Partial<AxiosRequestConfig> {
  params: PropertiesFromRecommendedRequestData
}

export interface GetPropertiesFromRecommendedResponseData extends ResponseData {
  data: PropertyDataV2[]
}

export interface GetPropertiesFromRecommendedResponse extends AxiosResponse {
  data: GetPropertiesFromRecommendedResponseData
}

export function getPropertiesFromRecommendedAPI(
  { params }: GetPropertiesFromRecommendedRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPropertiesFromRecommendedResponse> {
  const requestConfig: AxiosRequestConfig = {
    params,
    method: "get",
    url: "/home/recommended-properties",
  }
  return axiosInstance(
    requestConfig,
  ) as Promise<GetPropertiesFromRecommendedResponse>
}
